import React, { useState, useEffect } from 'react';
import './ComingSoonPopup.css';

const ComingSoonPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Show popup after a short delay on page load
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleNotify = (e) => {
    e.preventDefault();
    // Handle notification logic here
    alert('Thanks! We\'ll notify you when we launch.');
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={handleClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={handleClose}>×</button>
        <div className="popup-body">
          <div className="popup-icon">🚀</div>
          <h2 className="popup-title">Coming Soon</h2>
          <p className="popup-description">
            We're working hard to bring you something amazing. 
            Stay tuned for updates!
          </p>
          <form className="popup-form" onSubmit={handleNotify}>
            <input
              type="email"
              placeholder="Enter your email"
              className="popup-input"
              required
            />
            <button type="submit" className="popup-button">
              Notify Me
            </button>
          </form>
          <p className="popup-subtext">
            Be the first to know when we launch
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPopup;

